module.exports = __webpack_public_path__ + "media/media_library_book.e8afb9a3.mp3";